import { render, staticRenderFns } from "./MenuMember.vue?vue&type=template&id=2d26d98e&"
import script from "./MenuMember.vue?vue&type=script&lang=js&"
export * from "./MenuMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports